import Vue from 'vue';
import App from './App.vue';
import router from './router';
import Vant from 'vant';
import 'vant/lib/index.css';

import axios from 'axios'
import VueAxios from 'vue-axios'

axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*';
axios.defaults.timeout = 10000;
axios.defaults.baseURL = 'https://api.yiqinft.com';
// axios.defaults.baseURL = 'http://test.yiqinft.com';
// axios.defaults.baseURL = '/api';

Vue.use(VueAxios, axios)
Vue.use(Vant);
Vue.config.productionTip = false;

new Vue({
  render: h => h(App),
  router
}).$mount('#app')
